"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/commons/plugins/blink.controller.ts');
const plugins_1 = require("./plugins");
class BlinkController extends plugins_1.FdmPlugin {
    objectInjected() {
        this.startPulse();
    }
    pulse() {
        if (this.object) {
            this.object.show = false;
        }
    }
    pulseOff() {
        if (this.object) {
            this.object.show = true;
        }
    }
}
// required name identifier
BlinkController.meta = {
    label: 'PLUGINS.BLINKR.LABEL',
    name: 'blink-controller',
    tooltip: 'PLUGINS.BLINKR.TOOLTIP',
    translator: 'PLUGINS.BLINKR',
    icon: 'heartbeat',
    shortcut: false,
    category: plugins_1.FdmPlugin.category.generic,
    cardinality: plugins_1.FdmPlugin.cardinality.one,
    types: [plugins_1.FdmPlugin.types.transformController],
    features: [plugins_1.FdmPlugin.features.pulse],
    ds_types: [plugins_1.FdmPlugin.ds_types.all]
};
exports.BlinkController = BlinkController;
